import type { NextApiRequest, NextApiResponse } from 'next'
import { type GetOrderResponse, type Language, type PaymentProviderConfig } from 'ecosystem'
import { useLocaleCredentials as setLocaleCredentials } from 'api'
import { handlerWithLogging } from '../../../logging'
import { klarnaPaymentProvider } from './klarnaPaymentProvider'
import { nexiPaymentProvider } from './nexiPaymentProvider'
import { sveaPaymentProvider } from './sveaPaymentProvider'
import { qliroPaymentProvider } from './qliroPaymentProvider'
import { briqpayPaymentProvider } from './briqpayPaymentProvider'

export const getOrderHandler = handlerWithLogging(
  async (
    req: NextApiRequest,
    res: NextApiResponse<GetOrderResponse | { error: string }>,
    opts?: { paymentProviderConfig?: PaymentProviderConfig }
  ) => {
    if (req.method !== 'GET') {
      res.status(405).json({ error: 'Method not supported.' })
      return
    }

    const locale = (req.cookies.NEXT_LOCALE as Language) || 'sv'
    setLocaleCredentials(locale)

    switch (opts?.paymentProviderConfig?.providerName ?? 'KLARNA') {
      case 'KLARNA':
        return klarnaPaymentProvider(req, res)
      case 'NEXI':
        return nexiPaymentProvider(req, res)
      case 'SVEA': {
        return sveaPaymentProvider(req, res)
      }
      case 'QLIRO':
        return qliroPaymentProvider(req, res)
      case 'BRIQPAY':
        return briqpayPaymentProvider(req, res)
      // todo: add LEDYER
      case 'LEDYER': {
        throw new Error('Not implemented yet: "LEDYER" case')
      }
    }
  }
)
